@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-965_571_730)
internal val Res.string.exp_content_recap_imperfettivo_zeta_3: StringResource by lazy {
      StringResource("string:exp_content_recap_imperfettivo_zeta_3", "exp_content_recap_imperfettivo_zeta_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 113263, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 111859, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 113124, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 107759, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104843, 105),
      ))
    }

@delegate:ResourceContentHash(309_613_972)
internal val Res.string.exp_content_recap_imperfettivo_zeta_4: StringResource by lazy {
      StringResource("string:exp_content_recap_imperfettivo_zeta_4", "exp_content_recap_imperfettivo_zeta_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 113373, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 111969, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 113250, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 107861, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 104949, 141),
      ))
    }

@delegate:ResourceContentHash(1_066_710_950)
internal val Res.string.exp_content_recap_verbi_participi_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_recap_verbi_participi_alyn_1", "exp_content_recap_verbi_participi_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 113523, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 112103, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 113388, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 107999, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105091, 108),
      ))
    }

@delegate:ResourceContentHash(-636_610_182)
internal val Res.string.exp_content_recap_verbi_participi_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_recap_verbi_participi_nilo_1", "exp_content_recap_verbi_participi_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 113652, 144),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 112220, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 113505, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 108104, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105200, 108),
      ))
    }

@delegate:ResourceContentHash(-1_030_329_027)
internal val Res.string.exp_content_recap_verbi_participi_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_recap_verbi_participi_nilo_2", "exp_content_recap_verbi_participi_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 113797, 180),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 112341, 188),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 113622, 188),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 108221, 152),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105309, 164),
      ))
    }

@delegate:ResourceContentHash(954_675_719)
internal val Res.string.exp_content_recap_vso_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_recap_vso_alyn_1", "exp_content_recap_vso_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 113978, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 112530, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 113811, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 108374, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105474, 60),
      ))
    }

@delegate:ResourceContentHash(1_430_984_718)
internal val Res.string.exp_content_recap_vso_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_recap_vso_alyn_2", "exp_content_recap_vso_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 114043, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 112591, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 113868, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 108431, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105535, 80),
      ))
    }

@delegate:ResourceContentHash(1_863_371_388)
internal val Res.string.exp_content_recap_vso_alyn_3: StringResource by lazy {
      StringResource("string:exp_content_recap_vso_alyn_3", "exp_content_recap_vso_alyn_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 114132, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 112672, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 113961, 68),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 108508, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105616, 64),
      ))
    }

@delegate:ResourceContentHash(-1_622_043_137)
internal val Res.string.exp_content_recap_vso_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_recap_vso_nilo_1", "exp_content_recap_vso_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 114209, 188),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 112741, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 114030, 144),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 108569, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105681, 144),
      ))
    }

@delegate:ResourceContentHash(-1_496_736_984)
internal val Res.string.exp_content_recap_vso_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_recap_vso_nilo_2", "exp_content_recap_vso_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 114398, 76),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 112894, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 114175, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 108686, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105826, 72),
      ))
    }

@delegate:ResourceContentHash(-282_031_058)
internal val Res.string.exp_content_recap_vso_nilo_3: StringResource by lazy {
      StringResource("string:exp_content_recap_vso_nilo_3", "exp_content_recap_vso_nilo_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 114475, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 112967, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 114248, 112),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 108755, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 105899, 100),
      ))
    }

@delegate:ResourceContentHash(-2_051_582_106)
internal val Res.string.exp_content_recap_vso_nilo_4: StringResource by lazy {
      StringResource("string:exp_content_recap_vso_nilo_4", "exp_content_recap_vso_nilo_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 114588, 192),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 113068, 192),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 114361, 188),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 108856, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106000, 180),
      ))
    }

@delegate:ResourceContentHash(-1_682_909_338)
internal val Res.string.exp_content_recap_vso_nilo_5: StringResource by lazy {
      StringResource("string:exp_content_recap_vso_nilo_5", "exp_content_recap_vso_nilo_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 114781, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 113261, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 114550, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 109033, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106181, 76),
      ))
    }

@delegate:ResourceContentHash(-1_465_323_435)
internal val Res.string.exp_content_ricorda_di_norma_i_sostantivi_femminili_termi: StringResource by
    lazy {
      StringResource("string:exp_content_ricorda_di_norma_i_sostantivi_femminili_termi", "exp_content_ricorda_di_norma_i_sostantivi_femminili_termi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 114874, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 113342, 181),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 114639, 185),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 109102, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106258, 153),
      ))
    }

@delegate:ResourceContentHash(-974_274_057)
internal val Res.string.exp_content_ricorda_il_contesto_la_chiave_per_capire_se_s: StringResource by
    lazy {
      StringResource("string:exp_content_ricorda_il_contesto_la_chiave_per_capire_se_s", "exp_content_ricorda_il_contesto_la_chiave_per_capire_se_s", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 115040, 225),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 113524, 205),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 114825, 213),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 109272, 201),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106412, 189),
      ))
    }

@delegate:ResourceContentHash(256_085_730)
internal val Res.string.exp_content_rieccolo_di_nuovo_1: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_1", "exp_content_rieccolo_di_nuovo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116071, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 114551, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115876, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110267, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107355, 91),
      ))
    }

@delegate:ResourceContentHash(-744_001_685)
internal val Res.string.exp_content_rieccolo_di_nuovo_10: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_10", "exp_content_rieccolo_di_nuovo_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 115266, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 113730, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115039, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 109474, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106602, 96),
      ))
    }

@delegate:ResourceContentHash(-889_559_867)
internal val Res.string.exp_content_rieccolo_di_nuovo_11: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_11", "exp_content_rieccolo_di_nuovo_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 115371, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 113831, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115148, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 109567, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106699, 72),
      ))
    }

@delegate:ResourceContentHash(-247_681_467)
internal val Res.string.exp_content_rieccolo_di_nuovo_12: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_12", "exp_content_rieccolo_di_nuovo_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 115460, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 113912, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115245, 76),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 109652, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106772, 68),
      ))
    }

@delegate:ResourceContentHash(-1_813_837_542)
internal val Res.string.exp_content_rieccolo_di_nuovo_13: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_13", "exp_content_rieccolo_di_nuovo_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 115541, 80),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 113993, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115322, 72),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 109725, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106841, 84),
      ))
    }

@delegate:ResourceContentHash(1_409_594_186)
internal val Res.string.exp_content_rieccolo_di_nuovo_14: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_14", "exp_content_rieccolo_di_nuovo_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 115622, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 114074, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115395, 100),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 109806, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 106926, 100),
      ))
    }

@delegate:ResourceContentHash(924_717_042)
internal val Res.string.exp_content_rieccolo_di_nuovo_15: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_15", "exp_content_rieccolo_di_nuovo_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 115715, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 114175, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115496, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 109899, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107027, 104),
      ))
    }

@delegate:ResourceContentHash(1_507_629_246)
internal val Res.string.exp_content_rieccolo_di_nuovo_16: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_16", "exp_content_rieccolo_di_nuovo_16", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 115828, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 114284, 72),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115593, 76),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110012, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107132, 60),
      ))
    }

@delegate:ResourceContentHash(874_308_353)
internal val Res.string.exp_content_rieccolo_di_nuovo_17: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_17", "exp_content_rieccolo_di_nuovo_17", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 115893, 112),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 114357, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115670, 128),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110081, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107193, 96),
      ))
    }

@delegate:ResourceContentHash(-1_398_863_681)
internal val Res.string.exp_content_rieccolo_di_nuovo_18: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_18", "exp_content_rieccolo_di_nuovo_18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116006, 64),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 114482, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115799, 76),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110198, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107290, 64),
      ))
    }

@delegate:ResourceContentHash(31_872_216)
internal val Res.string.exp_content_rieccolo_di_nuovo_2: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_2", "exp_content_rieccolo_di_nuovo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116167, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 114647, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 115964, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110351, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107447, 55),
      ))
    }

@delegate:ResourceContentHash(1_374_332_375)
internal val Res.string.exp_content_rieccolo_di_nuovo_3: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_3", "exp_content_rieccolo_di_nuovo_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116223, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 114707, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 116028, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110407, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107503, 103),
      ))
    }

@delegate:ResourceContentHash(-1_653_078_823)
internal val Res.string.exp_content_rieccolo_di_nuovo_4: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_4", "exp_content_rieccolo_di_nuovo_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116315, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 114803, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 116120, 63),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110499, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107607, 55),
      ))
    }

@delegate:ResourceContentHash(534_159_616)
internal val Res.string.exp_content_rieccolo_di_nuovo_5: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_5", "exp_content_rieccolo_di_nuovo_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116375, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 114863, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 116184, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110559, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107663, 99),
      ))
    }

@delegate:ResourceContentHash(-1_273_699_101)
internal val Res.string.exp_content_rieccolo_di_nuovo_6: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_6", "exp_content_rieccolo_di_nuovo_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116487, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 114963, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 116284, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110659, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107763, 83),
      ))
    }

@delegate:ResourceContentHash(470_057_254)
internal val Res.string.exp_content_rieccolo_di_nuovo_7: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_7", "exp_content_rieccolo_di_nuovo_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116583, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 115035, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 116380, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110739, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107847, 91),
      ))
    }

@delegate:ResourceContentHash(-1_601_912_799)
internal val Res.string.exp_content_rieccolo_di_nuovo_8: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_8", "exp_content_rieccolo_di_nuovo_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116683, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 115127, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 116480, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110827, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107939, 51),
      ))
    }

@delegate:ResourceContentHash(1_830_508_075)
internal val Res.string.exp_content_rieccolo_di_nuovo_9: StringResource by lazy {
      StringResource("string:exp_content_rieccolo_di_nuovo_9", "exp_content_rieccolo_di_nuovo_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116735, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 115183, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 116536, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110879, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107991, 127),
      ))
    }

@delegate:ResourceContentHash(-1_375_445_200)
internal val Res.string.exp_content_ripassino_aggettivi_1: StringResource by lazy {
      StringResource("string:exp_content_ripassino_aggettivi_1", "exp_content_ripassino_aggettivi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116851, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 115287, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 116664, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 110999, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108119, 105),
      ))
    }

@delegate:ResourceContentHash(-261_926_486)
internal val Res.string.exp_content_ripassino_aggettivi_2: StringResource by lazy {
      StringResource("string:exp_content_ripassino_aggettivi_2", "exp_content_ripassino_aggettivi_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 116961, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 115405, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 116778, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 111113, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108225, 133),
      ))
    }

@delegate:ResourceContentHash(1_929_052_121)
internal val Res.string.exp_content_ripassino_aggettivi_3: StringResource by lazy {
      StringResource("string:exp_content_ripassino_aggettivi_3", "exp_content_ripassino_aggettivi_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 117115, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 115523, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 116912, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 111227, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108359, 113),
      ))
    }

@delegate:ResourceContentHash(180_245_413)
internal val Res.string.exp_content_ripassino_aggettivi_4: StringResource by lazy {
      StringResource("string:exp_content_ripassino_aggettivi_4", "exp_content_ripassino_aggettivi_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 117225, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 115641, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 117026, 149),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 111337, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108473, 137),
      ))
    }

@delegate:ResourceContentHash(-1_671_462_411)
internal val Res.string.exp_content_ripassino_aggettivi_5: StringResource by lazy {
      StringResource("string:exp_content_ripassino_aggettivi_5", "exp_content_ripassino_aggettivi_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 117383, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 115779, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 117176, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 111467, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108611, 101),
      ))
    }

@delegate:ResourceContentHash(-395_540_780)
internal val Res.string.exp_content_ripassino_aggettivi_6: StringResource by lazy {
      StringResource("string:exp_content_ripassino_aggettivi_6", "exp_content_ripassino_aggettivi_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 117505, 117),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 115885, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 117282, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 111573, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108713, 101),
      ))
    }

@delegate:ResourceContentHash(-1_836_409_404)
internal val Res.string.exp_content_ripasso_finito: StringResource by lazy {
      StringResource("string:exp_content_ripasso_finito", "exp_content_ripasso_finito", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 117623, 62),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 116007, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 117404, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 111691, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108815, 58),
      ))
    }

@delegate:ResourceContentHash(489_707_884)
internal val Res.string.exp_content_royal_names_full_intro: StringResource by lazy {
      StringResource("string:exp_content_royal_names_full_intro", "exp_content_royal_names_full_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 117686, 186),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 116074, 170),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 117471, 186),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 111750, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 108874, 170),
      ))
    }

@delegate:ResourceContentHash(-296_082_884)
internal val Res.string.exp_content_royal_names_full_tap_image: StringResource by lazy {
      StringResource("string:exp_content_royal_names_full_tap_image", "exp_content_royal_names_full_tap_image", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 117873, 202),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 116245, 206),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 117658, 222),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 111921, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109045, 178),
      ))
    }

@delegate:ResourceContentHash(404_531_756)
internal val Res.string.exp_content_royal_names_img_amenemhat: StringResource by lazy {
      StringResource("string:exp_content_royal_names_img_amenemhat", "exp_content_royal_names_img_amenemhat", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 118076, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 116452, 77),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 117881, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 112100, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109224, 77),
      ))
    }

@delegate:ResourceContentHash(-948_783_210)
internal val Res.string.exp_content_royal_names_img_mentuhotep: StringResource by lazy {
      StringResource("string:exp_content_royal_names_img_mentuhotep", "exp_content_royal_names_img_mentuhotep", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 118154, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 116530, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 117959, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 112178, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109302, 78),
      ))
    }

@delegate:ResourceContentHash(328_979_515)
internal val Res.string.exp_content_royal_names_img_neferhotep: StringResource by lazy {
      StringResource("string:exp_content_royal_names_img_neferhotep", "exp_content_royal_names_img_neferhotep", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 118237, 82),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 116649, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 118042, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 112301, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109381, 78),
      ))
    }

@delegate:ResourceContentHash(1_508_754_617)
internal val Res.string.exp_content_royal_names_img_tutankhamon: StringResource by lazy {
      StringResource("string:exp_content_royal_names_img_tutankhamon", "exp_content_royal_names_img_tutankhamon", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 118421, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 116817, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 118222, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 112477, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109553, 83),
      ))
    }

@delegate:ResourceContentHash(-681_208_771)
internal val Res.string.exp_content_royal_names_img_tutankhamon2: StringResource by lazy {
      StringResource("string:exp_content_royal_names_img_tutankhamon2", "exp_content_royal_names_img_tutankhamon2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 118320, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 116728, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 118125, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 112380, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109460, 92),
      ))
    }

@delegate:ResourceContentHash(-1_162_392_277)
internal val Res.string.exp_content_royal_names_intro: StringResource by lazy {
      StringResource("string:exp_content_royal_names_intro", "exp_content_royal_names_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 118505, 217),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 116973, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 118306, 197),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 112629, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109637, 189),
      ))
    }

@delegate:ResourceContentHash(-1_093_329_339)
internal val Res.string.exp_content_scorta_di_aggettivi_1: StringResource by lazy {
      StringResource("string:exp_content_scorta_di_aggettivi_1", "exp_content_scorta_di_aggettivi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 118723, 173),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 117151, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 118504, 177),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 112807, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109827, 157),
      ))
    }

@delegate:ResourceContentHash(-412_075_762)
internal val Res.string.exp_content_scorta_di_aggettivi_2: StringResource by lazy {
      StringResource("string:exp_content_scorta_di_aggettivi_2", "exp_content_scorta_di_aggettivi_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 118897, 133),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 117321, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 118682, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 112969, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 109985, 129),
      ))
    }

@delegate:ResourceContentHash(-1_565_135_010)
internal val Res.string.exp_content_scorta_di_aggettivi_3: StringResource by lazy {
      StringResource("string:exp_content_scorta_di_aggettivi_3", "exp_content_scorta_di_aggettivi_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 119031, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 117439, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 118828, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 113095, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110115, 113),
      ))
    }

@delegate:ResourceContentHash(-1_994_061_321)
internal val Res.string.exp_content_scorta_di_aggettivi_4: StringResource by lazy {
      StringResource("string:exp_content_scorta_di_aggettivi_4", "exp_content_scorta_di_aggettivi_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 119153, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 117557, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 118950, 105),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 113217, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110229, 81),
      ))
    }

@delegate:ResourceContentHash(412_025_917)
internal val Res.string.exp_content_scorta_di_aggettivi_5: StringResource by lazy {
      StringResource("string:exp_content_scorta_di_aggettivi_5", "exp_content_scorta_di_aggettivi_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 119267, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 117651, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 119056, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 113315, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110311, 121),
      ))
    }

@delegate:ResourceContentHash(-1_913_455_874)
internal val Res.string.exp_content_scorta_di_aggettivi_6: StringResource by lazy {
      StringResource("string:exp_content_scorta_di_aggettivi_6", "exp_content_scorta_di_aggettivi_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 119377, 113),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 117769, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 119178, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 113425, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110433, 105),
      ))
    }

@delegate:ResourceContentHash(524_968_764)
internal val Res.string.exp_content_scorta_di_aggettivi_7: StringResource by lazy {
      StringResource("string:exp_content_scorta_di_aggettivi_7", "exp_content_scorta_di_aggettivi_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 119491, 89),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 117875, 93),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 119288, 97),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 113523, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110539, 93),
      ))
    }

@delegate:ResourceContentHash(-1_713_014_644)
internal val Res.string.exp_content_sdm_f_alyn_react: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_alyn_react", "exp_content_sdm_f_alyn_react", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 119581, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 117969, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 119386, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 113613, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110633, 76),
      ))
    }

@delegate:ResourceContentHash(1_396_576_385)
internal val Res.string.exp_content_sdm_f_congiuntivo_1: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_1", "exp_content_sdm_f_congiuntivo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 120844, 123),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 119164, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 120621, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 114780, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111784, 99),
      ))
    }

@delegate:ResourceContentHash(-297_171_755)
internal val Res.string.exp_content_sdm_f_congiuntivo_10: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_10", "exp_content_sdm_f_congiuntivo_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 119666, 116),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 118062, 120),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 119475, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 113694, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110710, 124),
      ))
    }

@delegate:ResourceContentHash(-1_120_740_847)
internal val Res.string.exp_content_sdm_f_congiuntivo_11: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_11", "exp_content_sdm_f_congiuntivo_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 119783, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 118183, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 119600, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 113811, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110835, 100),
      ))
    }

@delegate:ResourceContentHash(-1_536_919_816)
internal val Res.string.exp_content_sdm_f_congiuntivo_12: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_12", "exp_content_sdm_f_congiuntivo_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 119904, 104),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 118276, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 119705, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 113908, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 110936, 104),
      ))
    }

@delegate:ResourceContentHash(190_167_488)
internal val Res.string.exp_content_sdm_f_congiuntivo_13: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_13", "exp_content_sdm_f_congiuntivo_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 120009, 128),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 118385, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 119822, 120),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 114005, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111041, 116),
      ))
    }

@delegate:ResourceContentHash(1_500_502_976)
internal val Res.string.exp_content_sdm_f_congiuntivo_14: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_14", "exp_content_sdm_f_congiuntivo_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 120138, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 118498, 136),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 119943, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 114122, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111158, 116),
      ))
    }

@delegate:ResourceContentHash(417_996_110)
internal val Res.string.exp_content_sdm_f_congiuntivo_15: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_15", "exp_content_sdm_f_congiuntivo_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 120271, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 118635, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 120076, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 114243, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111275, 104),
      ))
    }

@delegate:ResourceContentHash(1_877_226_075)
internal val Res.string.exp_content_sdm_f_congiuntivo_16: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_16", "exp_content_sdm_f_congiuntivo_16", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 120392, 96),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 118744, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 120185, 96),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 114352, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111380, 92),
      ))
    }

@delegate:ResourceContentHash(1_352_849_308)
internal val Res.string.exp_content_sdm_f_congiuntivo_17: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_17", "exp_content_sdm_f_congiuntivo_17", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 120489, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 118837, 96),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 120282, 104),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 114449, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111473, 92),
      ))
    }

@delegate:ResourceContentHash(-1_334_060_046)
internal val Res.string.exp_content_sdm_f_congiuntivo_18: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_18", "exp_content_sdm_f_congiuntivo_18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 120598, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 118934, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 120387, 124),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 114550, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111566, 116),
      ))
    }

@delegate:ResourceContentHash(-158_728_672)
internal val Res.string.exp_content_sdm_f_congiuntivo_19: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_19", "exp_content_sdm_f_congiuntivo_19", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 120719, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 119047, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 120512, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 114663, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111683, 100),
      ))
    }

@delegate:ResourceContentHash(322_501_495)
internal val Res.string.exp_content_sdm_f_congiuntivo_2: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_2", "exp_content_sdm_f_congiuntivo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 121226, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 119498, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 120975, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 115106, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112126, 99),
      ))
    }

@delegate:ResourceContentHash(-688_411_870)
internal val Res.string.exp_content_sdm_f_congiuntivo_20: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_20", "exp_content_sdm_f_congiuntivo_20", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 120968, 124),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 119268, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 120729, 112),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 114876, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111884, 116),
      ))
    }

@delegate:ResourceContentHash(-1_223_417_183)
internal val Res.string.exp_content_sdm_f_congiuntivo_21: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_21", "exp_content_sdm_f_congiuntivo_21", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 121093, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 119385, 112),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 120842, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 114989, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112001, 124),
      ))
    }

@delegate:ResourceContentHash(1_366_818_698)
internal val Res.string.exp_content_sdm_f_congiuntivo_3: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_3", "exp_content_sdm_f_congiuntivo_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 121330, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 119586, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 121091, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 115206, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112226, 91),
      ))
    }

@delegate:ResourceContentHash(1_502_671_532)
internal val Res.string.exp_content_sdm_f_congiuntivo_4: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_4", "exp_content_sdm_f_congiuntivo_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 121426, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 119682, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 121191, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 115294, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112318, 91),
      ))
    }

@delegate:ResourceContentHash(-625_999_684)
internal val Res.string.exp_content_sdm_f_congiuntivo_5: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_5", "exp_content_sdm_f_congiuntivo_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 121518, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 119766, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 121287, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 115382, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112410, 103),
      ))
    }

@delegate:ResourceContentHash(-1_178_931_065)
internal val Res.string.exp_content_sdm_f_congiuntivo_6: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_6", "exp_content_sdm_f_congiuntivo_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 121634, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 119886, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 121411, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 115494, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112514, 79),
      ))
    }

@delegate:ResourceContentHash(-1_297_843_497)
internal val Res.string.exp_content_sdm_f_congiuntivo_7: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_7", "exp_content_sdm_f_congiuntivo_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 121714, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 119954, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 121499, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 115574, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112594, 119),
      ))
    }

@delegate:ResourceContentHash(-43_509_236)
internal val Res.string.exp_content_sdm_f_congiuntivo_8: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_8", "exp_content_sdm_f_congiuntivo_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 121834, 143),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 120066, 123),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 121611, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 115682, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112714, 127),
      ))
    }

@delegate:ResourceContentHash(1_643_241_017)
internal val Res.string.exp_content_sdm_f_congiuntivo_9: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_congiuntivo_9", "exp_content_sdm_f_congiuntivo_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 121978, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 120190, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 121747, 127),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 115810, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112842, 115),
      ))
    }

@delegate:ResourceContentHash(1_675_655_023)
internal val Res.string.exp_content_sdm_f_nilo_react: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_nilo_react", "exp_content_sdm_f_nilo_react", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 122098, 92),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 120310, 76),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 121875, 92),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 115926, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 112958, 84),
      ))
    }

@delegate:ResourceContentHash(1_790_261_105)
internal val Res.string.exp_content_sdm_f_use_future: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_use_future", "exp_content_sdm_f_use_future", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 122191, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 120387, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 121968, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 116007, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113043, 52),
      ))
    }

@delegate:ResourceContentHash(-699_681_104)
internal val Res.string.exp_content_sdm_f_use_habitual: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_use_habitual", "exp_content_sdm_f_use_habitual", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 122244, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 120468, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 122029, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 116076, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113096, 90),
      ))
    }

@delegate:ResourceContentHash(-2_049_696_414)
internal val Res.string.exp_content_sdm_f_use_present: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_use_present", "exp_content_sdm_f_use_present", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 122347, 181),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 120563, 181),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 122128, 173),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 116171, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113187, 173),
      ))
    }

@delegate:ResourceContentHash(-1_582_487_119)
internal val Res.string.exp_content_sdm_f_use_subjunctive: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_use_subjunctive", "exp_content_sdm_f_use_subjunctive", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 122529, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 120745, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 122302, 169),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 116349, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113361, 145),
      ))
    }

@delegate:ResourceContentHash(-965_645_556)
internal val Res.string.exp_content_sdm_f_zeta_1: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_zeta_1", "exp_content_sdm_f_zeta_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 122679, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 120883, 140),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 122472, 156),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 116487, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113507, 136),
      ))
    }

@delegate:ResourceContentHash(-788_800_370)
internal val Res.string.exp_content_sdm_f_zeta_2: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_zeta_2", "exp_content_sdm_f_zeta_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 122820, 164),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 121024, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 122629, 164),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 116624, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113644, 156),
      ))
    }

@delegate:ResourceContentHash(367_437_094)
internal val Res.string.exp_content_sdm_f_zeta_3: StringResource by lazy {
      StringResource("string:exp_content_sdm_f_zeta_3", "exp_content_sdm_f_zeta_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 122985, 120),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 121193, 116),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 122794, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 116785, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113801, 100),
      ))
    }

@delegate:ResourceContentHash(-649_863_715)
internal val Res.string.exp_content_se_la_cosa_posseduta_femminile_il_simbolo_diventa:
    StringResource by lazy {
      StringResource("string:exp_content_se_la_cosa_posseduta_femminile_il_simbolo_diventa", "exp_content_se_la_cosa_posseduta_femminile_il_simbolo_diventa", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 123106, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 121310, 173),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 122911, 165),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 116882, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 113902, 161),
      ))
    }

@delegate:ResourceContentHash(-202_824_624)
internal val Res.string.exp_content_se_la_cosa_posseduta_femminile_plurale_diventa_n_y_w_t:
    StringResource by lazy {
      StringResource("string:exp_content_se_la_cosa_posseduta_femminile_plurale_diventa_n_y_w_t", "exp_content_se_la_cosa_posseduta_femminile_plurale_diventa_n_y_w_t", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 123272, 218),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 121484, 218),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 123077, 222),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 117044, 210),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114064, 210),
      ))
    }

@delegate:ResourceContentHash(-242_103_929)
internal val Res.string.exp_content_se_la_cosa_posseduta_maschile_plurale_diventa_n_y_w:
    StringResource by lazy {
      StringResource("string:exp_content_se_la_cosa_posseduta_maschile_plurale_diventa_n_y_w", "exp_content_se_la_cosa_posseduta_maschile_plurale_diventa_n_y_w", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 123491, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 121703, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 123300, 159),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 117255, 147),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114275, 155),
      ))
    }

@delegate:ResourceContentHash(1_132_399_060)
internal val Res.string.exp_content_se_lo_spazio_finiva_potevano_spezzare_una_par: StringResource by
    lazy {
      StringResource("string:exp_content_se_lo_spazio_finiva_potevano_spezzare_una_par", "exp_content_se_lo_spazio_finiva_potevano_spezzare_una_par", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 123647, 273),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 121859, 301),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 123460, 301),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 117403, 289),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114431, 249),
      ))
    }

@delegate:ResourceContentHash(-1_235_102_260)
internal val Res.string.exp_content_segni_degli_aggettivi_1: StringResource by lazy {
      StringResource("string:exp_content_segni_degli_aggettivi_1", "exp_content_segni_degli_aggettivi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 123921, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 122161, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 123762, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 117693, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114681, 91),
      ))
    }

@delegate:ResourceContentHash(568_499_330)
internal val Res.string.exp_content_segni_degli_aggettivi_2: StringResource by lazy {
      StringResource("string:exp_content_segni_degli_aggettivi_2", "exp_content_segni_degli_aggettivi_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 124021, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 122265, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 123866, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 117789, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114773, 51),
      ))
    }

@delegate:ResourceContentHash(1_029_711_740)
internal val Res.string.exp_content_segni_degli_aggettivi_3: StringResource by lazy {
      StringResource("string:exp_content_segni_degli_aggettivi_3", "exp_content_segni_degli_aggettivi_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 124073, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 122317, 99),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 123918, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 117841, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114825, 83),
      ))
    }

@delegate:ResourceContentHash(-530_231_324)
internal val Res.string.exp_content_segni_degli_aggettivi_4: StringResource by lazy {
      StringResource("string:exp_content_segni_degli_aggettivi_4", "exp_content_segni_degli_aggettivi_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 124173, 135),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 122417, 127),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 124002, 139),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 117937, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114909, 143),
      ))
    }

@delegate:ResourceContentHash(-674_997_614)
internal val Res.string.exp_content_segni_degli_aggettivi_5: StringResource by lazy {
      StringResource("string:exp_content_segni_degli_aggettivi_5", "exp_content_segni_degli_aggettivi_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 124309, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 122545, 111),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 124142, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 118061, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115053, 111),
      ))
    }

@delegate:ResourceContentHash(-587_341_351)
internal val Res.string.exp_content_segni_degli_aggettivi_6: StringResource by lazy {
      StringResource("string:exp_content_segni_degli_aggettivi_6", "exp_content_segni_degli_aggettivi_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 124417, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 122657, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 124246, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 118169, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115165, 119),
      ))
    }

@delegate:ResourceContentHash(365_060_145)
internal val Res.string.exp_content_segni_degli_aggettivi_7: StringResource by lazy {
      StringResource("string:exp_content_segni_degli_aggettivi_7", "exp_content_segni_degli_aggettivi_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 124537, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 122773, 155),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 124350, 159),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 118273, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115285, 131),
      ))
    }

@delegate:ResourceContentHash(1_406_999_130)
internal val Res.string.exp_content_segni_vari_1: StringResource by lazy {
      StringResource("string:exp_content_segni_vari_1", "exp_content_segni_vari_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 124685, 72),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 122929, 64),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 124510, 64),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 118417, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115417, 52),
      ))
    }

@delegate:ResourceContentHash(-1_274_651_612)
internal val Res.string.exp_content_segni_vari_2: StringResource by lazy {
      StringResource("string:exp_content_segni_vari_2", "exp_content_segni_vari_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 124758, 96),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 122994, 100),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 124575, 108),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 118482, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115470, 80),
      ))
    }

@delegate:ResourceContentHash(-1_001_363_817)
internal val Res.string.exp_content_segni_vari_3: StringResource by lazy {
      StringResource("string:exp_content_segni_vari_3", "exp_content_segni_vari_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 124855, 100),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 123095, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 124684, 100),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 118575, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115551, 84),
      ))
    }

@delegate:ResourceContentHash(-2_107_522_921)
internal val Res.string.exp_content_segni_vari_4: StringResource by lazy {
      StringResource("string:exp_content_segni_vari_4", "exp_content_segni_vari_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 124956, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 123188, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 124785, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 118656, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 115636, 48),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString10Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_content_recap_imperfettivo_zeta_3", Res.string.exp_content_recap_imperfettivo_zeta_3)
  map.put("exp_content_recap_imperfettivo_zeta_4", Res.string.exp_content_recap_imperfettivo_zeta_4)
  map.put("exp_content_recap_verbi_participi_alyn_1", Res.string.exp_content_recap_verbi_participi_alyn_1)
  map.put("exp_content_recap_verbi_participi_nilo_1", Res.string.exp_content_recap_verbi_participi_nilo_1)
  map.put("exp_content_recap_verbi_participi_nilo_2", Res.string.exp_content_recap_verbi_participi_nilo_2)
  map.put("exp_content_recap_vso_alyn_1", Res.string.exp_content_recap_vso_alyn_1)
  map.put("exp_content_recap_vso_alyn_2", Res.string.exp_content_recap_vso_alyn_2)
  map.put("exp_content_recap_vso_alyn_3", Res.string.exp_content_recap_vso_alyn_3)
  map.put("exp_content_recap_vso_nilo_1", Res.string.exp_content_recap_vso_nilo_1)
  map.put("exp_content_recap_vso_nilo_2", Res.string.exp_content_recap_vso_nilo_2)
  map.put("exp_content_recap_vso_nilo_3", Res.string.exp_content_recap_vso_nilo_3)
  map.put("exp_content_recap_vso_nilo_4", Res.string.exp_content_recap_vso_nilo_4)
  map.put("exp_content_recap_vso_nilo_5", Res.string.exp_content_recap_vso_nilo_5)
  map.put("exp_content_ricorda_di_norma_i_sostantivi_femminili_termi", Res.string.exp_content_ricorda_di_norma_i_sostantivi_femminili_termi)
  map.put("exp_content_ricorda_il_contesto_la_chiave_per_capire_se_s", Res.string.exp_content_ricorda_il_contesto_la_chiave_per_capire_se_s)
  map.put("exp_content_rieccolo_di_nuovo_1", Res.string.exp_content_rieccolo_di_nuovo_1)
  map.put("exp_content_rieccolo_di_nuovo_10", Res.string.exp_content_rieccolo_di_nuovo_10)
  map.put("exp_content_rieccolo_di_nuovo_11", Res.string.exp_content_rieccolo_di_nuovo_11)
  map.put("exp_content_rieccolo_di_nuovo_12", Res.string.exp_content_rieccolo_di_nuovo_12)
  map.put("exp_content_rieccolo_di_nuovo_13", Res.string.exp_content_rieccolo_di_nuovo_13)
  map.put("exp_content_rieccolo_di_nuovo_14", Res.string.exp_content_rieccolo_di_nuovo_14)
  map.put("exp_content_rieccolo_di_nuovo_15", Res.string.exp_content_rieccolo_di_nuovo_15)
  map.put("exp_content_rieccolo_di_nuovo_16", Res.string.exp_content_rieccolo_di_nuovo_16)
  map.put("exp_content_rieccolo_di_nuovo_17", Res.string.exp_content_rieccolo_di_nuovo_17)
  map.put("exp_content_rieccolo_di_nuovo_18", Res.string.exp_content_rieccolo_di_nuovo_18)
  map.put("exp_content_rieccolo_di_nuovo_2", Res.string.exp_content_rieccolo_di_nuovo_2)
  map.put("exp_content_rieccolo_di_nuovo_3", Res.string.exp_content_rieccolo_di_nuovo_3)
  map.put("exp_content_rieccolo_di_nuovo_4", Res.string.exp_content_rieccolo_di_nuovo_4)
  map.put("exp_content_rieccolo_di_nuovo_5", Res.string.exp_content_rieccolo_di_nuovo_5)
  map.put("exp_content_rieccolo_di_nuovo_6", Res.string.exp_content_rieccolo_di_nuovo_6)
  map.put("exp_content_rieccolo_di_nuovo_7", Res.string.exp_content_rieccolo_di_nuovo_7)
  map.put("exp_content_rieccolo_di_nuovo_8", Res.string.exp_content_rieccolo_di_nuovo_8)
  map.put("exp_content_rieccolo_di_nuovo_9", Res.string.exp_content_rieccolo_di_nuovo_9)
  map.put("exp_content_ripassino_aggettivi_1", Res.string.exp_content_ripassino_aggettivi_1)
  map.put("exp_content_ripassino_aggettivi_2", Res.string.exp_content_ripassino_aggettivi_2)
  map.put("exp_content_ripassino_aggettivi_3", Res.string.exp_content_ripassino_aggettivi_3)
  map.put("exp_content_ripassino_aggettivi_4", Res.string.exp_content_ripassino_aggettivi_4)
  map.put("exp_content_ripassino_aggettivi_5", Res.string.exp_content_ripassino_aggettivi_5)
  map.put("exp_content_ripassino_aggettivi_6", Res.string.exp_content_ripassino_aggettivi_6)
  map.put("exp_content_ripasso_finito", Res.string.exp_content_ripasso_finito)
  map.put("exp_content_royal_names_full_intro", Res.string.exp_content_royal_names_full_intro)
  map.put("exp_content_royal_names_full_tap_image", Res.string.exp_content_royal_names_full_tap_image)
  map.put("exp_content_royal_names_img_amenemhat", Res.string.exp_content_royal_names_img_amenemhat)
  map.put("exp_content_royal_names_img_mentuhotep", Res.string.exp_content_royal_names_img_mentuhotep)
  map.put("exp_content_royal_names_img_neferhotep", Res.string.exp_content_royal_names_img_neferhotep)
  map.put("exp_content_royal_names_img_tutankhamon", Res.string.exp_content_royal_names_img_tutankhamon)
  map.put("exp_content_royal_names_img_tutankhamon2", Res.string.exp_content_royal_names_img_tutankhamon2)
  map.put("exp_content_royal_names_intro", Res.string.exp_content_royal_names_intro)
  map.put("exp_content_scorta_di_aggettivi_1", Res.string.exp_content_scorta_di_aggettivi_1)
  map.put("exp_content_scorta_di_aggettivi_2", Res.string.exp_content_scorta_di_aggettivi_2)
  map.put("exp_content_scorta_di_aggettivi_3", Res.string.exp_content_scorta_di_aggettivi_3)
  map.put("exp_content_scorta_di_aggettivi_4", Res.string.exp_content_scorta_di_aggettivi_4)
  map.put("exp_content_scorta_di_aggettivi_5", Res.string.exp_content_scorta_di_aggettivi_5)
  map.put("exp_content_scorta_di_aggettivi_6", Res.string.exp_content_scorta_di_aggettivi_6)
  map.put("exp_content_scorta_di_aggettivi_7", Res.string.exp_content_scorta_di_aggettivi_7)
  map.put("exp_content_sdm_f_alyn_react", Res.string.exp_content_sdm_f_alyn_react)
  map.put("exp_content_sdm_f_congiuntivo_1", Res.string.exp_content_sdm_f_congiuntivo_1)
  map.put("exp_content_sdm_f_congiuntivo_10", Res.string.exp_content_sdm_f_congiuntivo_10)
  map.put("exp_content_sdm_f_congiuntivo_11", Res.string.exp_content_sdm_f_congiuntivo_11)
  map.put("exp_content_sdm_f_congiuntivo_12", Res.string.exp_content_sdm_f_congiuntivo_12)
  map.put("exp_content_sdm_f_congiuntivo_13", Res.string.exp_content_sdm_f_congiuntivo_13)
  map.put("exp_content_sdm_f_congiuntivo_14", Res.string.exp_content_sdm_f_congiuntivo_14)
  map.put("exp_content_sdm_f_congiuntivo_15", Res.string.exp_content_sdm_f_congiuntivo_15)
  map.put("exp_content_sdm_f_congiuntivo_16", Res.string.exp_content_sdm_f_congiuntivo_16)
  map.put("exp_content_sdm_f_congiuntivo_17", Res.string.exp_content_sdm_f_congiuntivo_17)
  map.put("exp_content_sdm_f_congiuntivo_18", Res.string.exp_content_sdm_f_congiuntivo_18)
  map.put("exp_content_sdm_f_congiuntivo_19", Res.string.exp_content_sdm_f_congiuntivo_19)
  map.put("exp_content_sdm_f_congiuntivo_2", Res.string.exp_content_sdm_f_congiuntivo_2)
  map.put("exp_content_sdm_f_congiuntivo_20", Res.string.exp_content_sdm_f_congiuntivo_20)
  map.put("exp_content_sdm_f_congiuntivo_21", Res.string.exp_content_sdm_f_congiuntivo_21)
  map.put("exp_content_sdm_f_congiuntivo_3", Res.string.exp_content_sdm_f_congiuntivo_3)
  map.put("exp_content_sdm_f_congiuntivo_4", Res.string.exp_content_sdm_f_congiuntivo_4)
  map.put("exp_content_sdm_f_congiuntivo_5", Res.string.exp_content_sdm_f_congiuntivo_5)
  map.put("exp_content_sdm_f_congiuntivo_6", Res.string.exp_content_sdm_f_congiuntivo_6)
  map.put("exp_content_sdm_f_congiuntivo_7", Res.string.exp_content_sdm_f_congiuntivo_7)
  map.put("exp_content_sdm_f_congiuntivo_8", Res.string.exp_content_sdm_f_congiuntivo_8)
  map.put("exp_content_sdm_f_congiuntivo_9", Res.string.exp_content_sdm_f_congiuntivo_9)
  map.put("exp_content_sdm_f_nilo_react", Res.string.exp_content_sdm_f_nilo_react)
  map.put("exp_content_sdm_f_use_future", Res.string.exp_content_sdm_f_use_future)
  map.put("exp_content_sdm_f_use_habitual", Res.string.exp_content_sdm_f_use_habitual)
  map.put("exp_content_sdm_f_use_present", Res.string.exp_content_sdm_f_use_present)
  map.put("exp_content_sdm_f_use_subjunctive", Res.string.exp_content_sdm_f_use_subjunctive)
  map.put("exp_content_sdm_f_zeta_1", Res.string.exp_content_sdm_f_zeta_1)
  map.put("exp_content_sdm_f_zeta_2", Res.string.exp_content_sdm_f_zeta_2)
  map.put("exp_content_sdm_f_zeta_3", Res.string.exp_content_sdm_f_zeta_3)
  map.put("exp_content_se_la_cosa_posseduta_femminile_il_simbolo_diventa", Res.string.exp_content_se_la_cosa_posseduta_femminile_il_simbolo_diventa)
  map.put("exp_content_se_la_cosa_posseduta_femminile_plurale_diventa_n_y_w_t", Res.string.exp_content_se_la_cosa_posseduta_femminile_plurale_diventa_n_y_w_t)
  map.put("exp_content_se_la_cosa_posseduta_maschile_plurale_diventa_n_y_w", Res.string.exp_content_se_la_cosa_posseduta_maschile_plurale_diventa_n_y_w)
  map.put("exp_content_se_lo_spazio_finiva_potevano_spezzare_una_par", Res.string.exp_content_se_lo_spazio_finiva_potevano_spezzare_una_par)
  map.put("exp_content_segni_degli_aggettivi_1", Res.string.exp_content_segni_degli_aggettivi_1)
  map.put("exp_content_segni_degli_aggettivi_2", Res.string.exp_content_segni_degli_aggettivi_2)
  map.put("exp_content_segni_degli_aggettivi_3", Res.string.exp_content_segni_degli_aggettivi_3)
  map.put("exp_content_segni_degli_aggettivi_4", Res.string.exp_content_segni_degli_aggettivi_4)
  map.put("exp_content_segni_degli_aggettivi_5", Res.string.exp_content_segni_degli_aggettivi_5)
  map.put("exp_content_segni_degli_aggettivi_6", Res.string.exp_content_segni_degli_aggettivi_6)
  map.put("exp_content_segni_degli_aggettivi_7", Res.string.exp_content_segni_degli_aggettivi_7)
  map.put("exp_content_segni_vari_1", Res.string.exp_content_segni_vari_1)
  map.put("exp_content_segni_vari_2", Res.string.exp_content_segni_vari_2)
  map.put("exp_content_segni_vari_3", Res.string.exp_content_segni_vari_3)
  map.put("exp_content_segni_vari_4", Res.string.exp_content_segni_vari_4)
}
